app.menu = {
	settings: {
		menu: '#nav-bar',
		mobileMenuOpenSelector: '[data-mobile-menu-open]',
		mobileMenuCloseSelector: '[data-mobile-menu-close]'
	},

	init: function() {
		app.settings.$document.on('click', app.menu.settings.mobileMenuOpenSelector, function(event){
			event.preventDefault();

			$(app.menu.settings.menu).addClass('mobile-menu--show');
		});

		app.settings.$document.on('click', app.menu.settings.mobileMenuCloseSelector, function(event){
			event.preventDefault();

			$(app.menu.settings.menu).removeClass('mobile-menu--show');
		});

		app.settings.$document.on('click', '.menu-item--submenu .menu-link', function(event){
			event.preventDefault();

			$('.menu-item--submenu').not($(this).parent('.menu-item--submenu')).removeClass('menu-item--submenu-open');

			$(this).parent('.menu-item--submenu').toggleClass('menu-item--submenu-open');
		});

		$( '.menu-bar li:has(.menu-bar__sub)' ).doubleTapToGo();
	}
};